import React from 'react';
import PropTypes from 'prop-types';
import { StyledParagraph } from './components/TextStyles';

const Text = ({ children, as, color, size, weight, className }) => {
  return (
    <StyledParagraph as={as} color={color} size={size} weight={weight} className={className}>
      {children}
    </StyledParagraph>
  );
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.oneOf(['p', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label']),
  color: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  weight: PropTypes.oneOf(['normal', 'bold', '600', '700', '800']),
  className: PropTypes.string,
};

Text.defaultProps = {
  as: 'p',
  color: undefined,
  size: 'md',
  weight: 'normal',
  className: '',
};

export default Text;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Text/Text.jsx